export default __webpack_public_path__ + "static/instagram-logo-black-f17dfc7783ea8b3bb5f7658c0cba5426.png";